/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface BucketFiltersProps {
    searchQuery: string;
    onSearchChange: (value: string) => void;
    visibilityFilter: 'all' | 'public' | 'private';
    onVisibilityChange: (value: 'all' | 'public' | 'private') => void;
    sortBy: 'created-newest' | 'created-oldest' | 'name-asc' | 'name-desc';
    onSortChange: (value: 'created-newest' | 'created-oldest' | 'name-asc' | 'name-desc') => void;
}

const BucketFilters: React.FC<BucketFiltersProps> = ({
    searchQuery,
    onSearchChange,
    visibilityFilter,
    onVisibilityChange,
    sortBy,
    onSortChange,
}) => {
    return (
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
            <div className="flex flex-col sm:flex-row gap-3 flex-1">
                {/* Search */}
                <div className="relative flex-1 max-w-md">
                    <MagnifyingGlassIcon className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
                    <input
                        type="text"
                        placeholder="Search buckets..."
                        value={searchQuery}
                        onChange={(e) => onSearchChange(e.target.value)}
                        className="input pl-10 w-full"
                    />
                </div>

                {/* Visibility Filter */}
                <select
                    value={visibilityFilter}
                    onChange={(e) => onVisibilityChange(e.target.value as typeof visibilityFilter)}
                    className="input w-auto"
                >
                    <option value="all">All Visibility</option>
                    <option value="public">Public</option>
                    <option value="private">Private</option>
                </select>

                {/* Sort Dropdown */}
                <select
                    value={sortBy}
                    onChange={(e) => onSortChange(e.target.value as typeof sortBy)}
                    className="input w-auto"
                >
                    <option value="created-newest">Newest First</option>
                    <option value="created-oldest">Oldest First</option>
                    <option value="name-asc">Name (A–Z)</option>
                    <option value="name-desc">Name (Z–A)</option>
                </select>
            </div>
        </div>
    );
};

export default BucketFilters;
